// Wording for the check-in timer (spec 004), the same as the apps' shared
// CheckIns, from i18n/common (spec 013 FR-010).
import { t, time, weekday } from '../i18n/index.ts';

// clockAt is a time of day, "9:45 PM", with the day when it is not today.
export function clockAt(iso: string): string {
  const d = new Date(iso);
  return d.toDateString() === new Date().toDateString() ? time(d) : t('checkinAtDay', { day: weekday(d, true), time: time(d) });
}

// left is the time left until due, "1 h 12 min left", or how long ago it passed.
export function left(dueIso: string, now: number): string {
  const s = Math.round((new Date(dueIso).getTime() - now) / 1000);
  const a = Math.abs(s);
  const h = Math.floor(a / 3600);
  const m = Math.floor((a % 3600) / 60);
  const text = h > 0 ? t('durationHoursMinutes', { hours: h, minutes: m }) : m > 0 ? t('durationMinutes', { minutes: m }) : t('durationSeconds', { seconds: a % 60 });
  return s >= 0 ? t('checkinLeft', { duration: text }) : t('checkinOverdue', { duration: text });
}
